import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import AiLogin from "@/content/commonLogin.vue";
import AiCompLogin from "@/content/componentLogin.vue";
import { CandidateResult } from "@/lib/model/exam/result";
import { Ver } from "@/lib/model/question/question";
import vuexStore from "@/store/vuex-store";
import Auth from "@/lib/common/auth";
import Config from "@/config/config";
import Cookie from "@/lib/common/cookie";
import Constraint from "@/lib/common/constraint";

//设备查询
function isMobile(): boolean {
  const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
  const isAndroid = /(Android)/i.test(navigator.userAgent);
  return isIos || isAndroid;
}
//特判公司标记 富士康
// const isFSK = [90528, 91359, 91237, 91415, 1010, 173, 194];
const isNr = document.URL.includes("nrpla") || document.URL.includes("public"); //牛人星球 客户端 || 候选人端

enum ExamType {
  "examV2" = "",
  "examV3" = "0331"
}

Vue.use(VueRouter);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  // eslint-disable-next-line prettier/prettier
  return (originalPush as any).call(this, location).catch((err: any) => err)
};

const routes: Array<RouteConfig> = [
  {
    path: "/cockpit-login",
    name: "cockpit-login",
    component: () => import("@/views/data-cockpit/cockpit-login.vue")
  },
  {
    path: "/data-cockpit",
    name: "data-cockpit",
    component: () => import("@/views/data-cockpit/index.vue")
  },
  {
    path: "/zztest",
    name: "zztest",
    component: () => import("@/views/zz/test.vue")
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test/index.vue")
  },
  {
    path: "/",
    name: "Index",
    component: AiLogin
  },
  {
    path: "/comp-login",
    name: "CompLogin",
    component: AiCompLogin
  },
  {
    path: "/sso",
    name: "Sso",
    component: () => import("@/views/Sso.vue")
  },
  {
    path: "/code",
    name: "code",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/code.vue"),
    beforeEnter: (to, from, next) => {
      //带的参
      let queryString = "";
      if (to.query) {
        for (const k in to.query) {
          queryString += k + "=" + to.query[k] + "&";
        }
      }

      // 判断是否为1.5版本的面试和候选人
      const c = String(to?.query?.c || "");

      if (c.startsWith("1") || c.startsWith("2") || c.startsWith("3")) {
        return next("/code-component?" + queryString);
      }

      next();
    }
  },
  {
    path: "/code-component",
    name: "code-component",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/code-component.vue")
  },
  // AI-builder => AI智面小程序
  // 人脸核身
  {
    path: "/fv",
    name: "fv",
    component: () => import("@/views/face-verify/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/walmart",
    name: "walmart",
    component: () => import("@/views/walmart/walmart.vue")
  },
  //面试官评估 登录页
  {
    path: "/hr-login",
    name: "hr-login",
    component: () => import("@/views/ai-group/hr-login.vue")
  },
  // {
  //   path: "/notfound",
  //   name: "notfound",
  //   component: () => import("@/views/error/404.vue")
  // },
  {
    path: "/no-auth",
    name: "no-auth",
    component: () => import("@/views/no-auth.vue")
  },
  {
    path: "/sf-export",
    name: "sf-export",
    meta: {
      needCompany: true,
      needToken: true
    },
    component: () => import("@/views/paper/sf-export.vue")
  },
  // AI面试护照核身
  {
    path: "/identity-ai",
    name: "id-ai",
    meta: {
      needCompany: false,
      needToken: true
    },
    component: () => import("@/views/identity/id-ai.vue")
  },
  // 使用人脸核身
  {
    path: "/identity-face-exam",
    name: "identity-face-exam",
    meta: {
      needCompany: false,
      needToken: true
    },
    component: () => import("@/views/identity/id-face-exam.vue")
  },
  // 笔面试护照核身
  {
    path: "/identity-card-exam",
    name: "identity-card-exam",
    meta: {
      needCompany: false,
      needToken: true
    },
    component: () => import("@/views/identity/id-card-exam.vue")
  },
  // 笔面试核身选择
  {
    path: "/identity-exam",
    name: "identity-exam",
    meta: {
      needCompany: false,
      needToken: true
    },
    component: () => import("@/views/identity/id-exam.vue")
  },
  // AiBuilderv3创建模板页
  {
    path: "/tem-builder",
    name: "tem-builder",
    meta: { examType: "examV3" },
    component: () => import("@/views/ai-builder-v3/tem-builder.vue")
  },
  //主界面路由
  {
    path: "/home",
    name: "exam-home",
    meta: {
      needToken: false
    },
    component: () => import("@/views/Home.vue"),
    children: [
      {
        path: "/dash",
        name: "dash",
        meta: { examType: "examV2" },
        component: () => import("@/views/dash/dash.vue")
      },
      {
        path: "/dash-v3",
        name: "dash-v3",
        meta: { examType: "examV3" },
        component: () => import("@/views/dash/dash-v3.vue")
      },
      {
        path: "/list/exam",
        name: "list-exam",
        component: () => import("@/views/list/exam.vue")
      },
      {
        path: "/list/preach",
        name: "list-preach",
        component: () => import("@/views/list/preach.vue")
      },
      {
        path: "/exam/xueersi",
        name: "exam-xueersi",
        component: () => import("@/views/exam/xueersi.vue")
      },
      {
        path: "/paper/edit",
        name: "paper-edit",
        component: () => import("@/views/paper/edit.vue")
      },
      {
        path: "/paper/finish",
        name: "paper-finish",
        component: () => import("@/views/paper/finish.vue")
      },
      {
        path: "/question/select",
        name: "question-select",
        component: () => import("@/views/question/select.vue")
      },
      {
        path: "/cssTest/cssTest",
        name: "css-test",
        component: () => import("@/views/cssTest/cssTest.vue")
      },
      {
        path: "/exam/paper",
        name: "exam-paper",
        meta: {
          keepAlive: true,
          examType: "examV2"
        },
        component: () => import("@/views/paper/list.vue")
      },
      {
        path: "/exam/paper-sf",
        name: "exam-paper-sf",
        meta: {
          keepAlive: true,
          examType: "examV2"
        },
        component: () => import("@/views/paper/list-sf.vue")
      },
      {
        path: "/exam/list",
        name: "exam-list-v3",
        meta: {
          keepAlive: true,
          examType: "examV3"
        },
        component: () => import("@/views/exam-v3/exam/list.vue")
      },
      {
        path: "/exam/candidates",
        name: "exam-candidates",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/exam-v3/exam/exam-candidates.vue")
      },
      {
        path: "/exam-paperList/:paperId?",
        name: "exam-paper-list",
        component: () => import("@/views/paper/paper-list.vue")
      },
      {
        path: "/exam-paperList-sf/:paperId?",
        name: "exam-paper-list-sf",
        component: () => import("@/views/paper/paper-list.vue")
      },
      {
        path: "/ai-question-store",
        name: "ai-question-store",
        meta: { examType: "examV2" },
        component: () => import("@/views/ai-builder/question-store.vue")
      },
      {
        path: "/ai-question-store-sf",
        name: "ai-question-store-sf",
        meta: { examType: "examV2" },
        component: () => import("@/views/ai-builder/question-store.vue")
      },
      {
        path: "/question-store",
        name: "question-store",
        meta: { examType: "examV2" },
        component: () => import("@/views/paper/question-store.vue")
      },
      {
        path: "/question-paper",
        name: "question-paper",
        component: () => import("@/views/paper/question-paper.vue")
      },
      {
        path: "/question-paper-sf",
        name: "question-paper-sf",
        component: () => import("@/views/paper/question-paper.vue")
      },
      {
        path: "/ask-paper",
        name: "ask-paper",
        component: () => import("@/views/paper/ask-paper.vue")
      },
      {
        path: "/exam/mark-mobile",
        name: "paper-mark-mobile",
        meta: {
          needCompany: false,
          needToken: false,
          allowBack: false
        },
        component: () => import("@/views/exam/mark-mobile.vue")
      },
      // {
      //   path: "/paper-mark",
      //   name: "paper-mark",
      //   meta: {
      //     needCompany: false,
      //     needToken: false
      //   },
      //   component: () => import("@/views/exam/paper-mark.vue")
      // },

      // {
      //   path: "/add-question/:paperId?",
      //   name: "add-question",
      //   meta: {
      //     needCompany: true,
      //     needToken: true,
      //   },
      //   component: () => import("@/views/paper/add-question.vue")
      // },
      {
        path: "/paper-info",
        name: "paper-info",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/paper/paper-info.vue")
      },
      {
        path: "/paper-info-sf",
        name: "paper-info-sf",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/paper/paper-info-sf.vue")
      },
      {
        path: "/paper-bgcheck",
        name: "paper-bgcheck",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/paper/paper-bgcheck.vue")
      },
      {
        path: "/paper-edit",
        name: "paper-edit",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/paper/paper-edit.vue")
      },
      {
        path: "/paper-result",
        name: "paper-result",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/paper/paper-result.vue")
      },
      {
        path: "/setting/user",
        name: "setting-user",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/setting/user.vue")
      },
      {
        path: "/setting/company",
        name: "setting-company",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/setting/company.vue")
      },
      {
        path: "/setting/team",
        name: "setting-team",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/setting/team.vue")
      },
      {
        path: "/setting/department",
        name: "setting-department",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/setting/department.vue")
      },
      {
        path: "/setting/notice",
        name: "setting-notice",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/setting/notice.vue")
      },
      {
        path: "/setting/trade",
        name: "setting-trade",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/setting/trade.vue")
      },
      {
        path: "/export-pdf",
        name: "export-pdf",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/paper/export-pdf.vue")
      },
      // 虚拟主播
      {
        path: "/vir/manual",
        name: "vir-manual",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/vir/manual.vue")
      },
      {
        path: "/vir/manage",
        name: "vir-manage",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/vir/manage.vue")
      },
      {
        path: "/vir/export",
        name: "vir-export",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/vir/export.vue")
      },
      {
        path: "/message/log",
        name: "message-log",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/message/log.vue")
      },

      //消息管理列表
      {
        path: "/message/list",
        name: "message-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/message/message-list.vue")
      },
      //模板管理列表
      {
        path: "/messageTemp/list",
        name: "messageTemp-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/message/messageTemp-list.vue")
      },
      //模板管理列表
      {
        path: "/export/list",
        name: "export-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/export/list.vue")
      },
      // 瑞幸需求：面试灰度 Interview experiment Luckin src/views/
      {
        path: "/interview-experiment",
        name: "interview-experiment",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/interview-experiment/index.vue")
      },
      {
        path: "/ai-qa/list",
        name: "ai-qa-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/ai-qa-officer/list.vue")
      },
      {
        path: "/company/config",
        name: "company-config",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/company/config.vue")
      },
      {
        path: "/exam-candidate",
        name: "exam-candidate",
        meta: {
          needCompany: true,
          needToken: true,
          examType: "examV2"
        },
        component: () => import("@/views/paper/candidate.vue")
      },
      {
        path: "/candidate/list",
        name: "candidate-list",
        meta: {
          needCompany: true,
          needToken: true,
          examType: "examV3"
        },
        component: () => import("@/views/exam-v3/candidate/list.vue")
      },
      {
        path: "/template-store",
        name: "template-store",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/template-store/template-store.vue")
      },
      {
        path: "/job-list",
        name: "job-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/job/job-list.vue")
      },
      //Aibuilder
      {
        path: "/ai-builder",
        name: "ai-builder",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/ai-builder/ai-builder.vue")
      },
      //Aibuilder -v3
      {
        path: "/aihr-builder",
        name: "aihr-builder",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/ai-builder-v3/ai-builder.vue")
      },
      //多人面试
      {
        path: "/ai-group",
        name: "ai-group",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/ai-group/ai-group.vue")
      },
      //Aibuilder 创建普工流程
      {
        path: "/ai-builder-worker",
        name: "ai-builder-worker",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () =>
          import("@/views/ai-builder-worker/ai-builder-worker.vue")
      },
      //ats 客户管理（牛人星球）
      {
        path: "/ats-manager",
        name: "ats-manager",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/ats/custom-list.vue")
      },
      //ats 牛人推（牛人星球）
      {
        path: "/nr-recommend",
        name: "nr-recommend",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/page/pushList.vue")
      }, //ats 大咖指路（牛人星球）
      {
        path: "/daka-list",
        name: "daka-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/page/dakaList.vue")
      },
      //ats 简历详情（牛人星球）
      {
        path: "/ats-cv",
        name: "ats-cv",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/ats/cv-detail.vue")
      },
      //ats 客户详情
      {
        path: "/ats-detail",
        name: "ats-detail",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/ats/custom-detail-list.vue")
      },
      //ats 应聘详情
      {
        path: "/ats-candidate",
        name: "ats-candidate",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/ats/custom-candidate-list.vue")
      },
      // 内部 标签管理
      {
        path: "/tag/list",
        name: "tag-list",
        component: () => import("@/views/tag/list.vue")
      }
    ]
  },
  // 组件化主界面路由
  {
    path: "/home-component",
    name: "exam-home-component",
    meta: {
      needToken: false
    },
    component: () => import("@/views/home-component.vue"),
    children: [
      // {
      //   path: "/dash-comp",
      //   name: "dash-comp",
      //   meta: { examType: "examV3" },
      //   component: () => import("@/views/dash-component/dash-v3.vue")
      // },
      {
        path: "/exam-component/paper",
        name: "exam-component-paper",
        meta: { examType: "examV2" },
        component: () => import("@/views/exam-component/exam/list.vue")
      },
      {
        path: "/exam-component/candidate",
        name: "exam-component-candidate",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () =>
          import("@/views/exam-component/exam/exam-candidates.vue")
      },
      {
        path: "/candidate-component/list",
        name: "candidate-component-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/exam-component/candidate/list.vue")
      },
      {
        path: "/ai-question-store-comp",
        name: "ai-question-store-comp",
        meta: { examType: "examV2" },
        component: () =>
          import("@/views/ai-builder-component/question-store.vue")
      },
      {
        path: "/message-comp/list",
        name: "message-comp-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () =>
          import("@/views/message-component/message-list-new.vue")
      },
      {
        path: "/message-temp-comp/list",
        name: "message-temp-comp-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () =>
          import("@/views/message-component/messageTemp-list-new.vue")
      },
      {
        path: "/export-component/list",
        name: "export-component-list",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/export-component/list.vue")
      },
      {
        path: "/ai-qa/list-comp",
        name: "ai-qa-list-comp",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () =>
          import("@/views/ai-builder-component/ai-qa-officer/list.vue")
      },
      {
        path: "/company/config-comp",
        name: "company-config-comp",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/company/config.vue")
      },
      {
        path: "/ai-builder-component",
        name: "ai-builder-component",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/ai-builder-component/ai-builder.vue")
      }
    ]
  }
];

//牛人星球 公开页面路由
const routesNr: RouteConfig[] = [
  {
    path: "/public",
    name: "login-nr",
    meta: {
      needToken: false
    },
    component: () => import("@/views/nr/login.vue")
  },
  {
    path: "/",
    name: "candidate-nr",
    meta: {
      needToken: false
    },
    component: () => import("@/views/paper/paper-result.vue")
  },
  {
    path: "/public/login-nr",
    name: "login-nr",
    meta: {
      needToken: false
    },
    component: () => import("@/views/nr/login.vue")
  },
  {
    path: "/public/home-nr",
    name: "home-nr",
    meta: {
      needToken: false
    },
    component: () => import("@/views/nr/home.vue"),
    children: [
      {
        path: "/public/list-nr",
        name: "list-nr",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/page/list.vue")
      },
      //牛人推
      {
        path: "/public/pushList-nr",
        name: "pushList-nr",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/page/pushList.vue")
      }, //ats 大咖指路（牛人星球）
      {
        path: "/public/daka-list-nr",
        name: "public-daka-list-nr",
        meta: {
          needCompany: true,
          needToken: true
        },
        component: () => import("@/views/nr/page/dakaList.vue")
      },
      //ats 公开编辑简历页  （候选人端）
      {
        path: "/public/edit",
        name: "public-edit",
        meta: {
          needCompany: false,
          needToken: false
        },
        component: () => import("@/views/nr/page/public-edit.vue")
      }
    ]
  }
];
//是否h5阅卷页
if (!isMobile()) {
  routes.push({
    path: "/exam/mark",
    name: "paper-mark",
    meta: {
      needCompany: false,
      needToken: false,
      allowBack: false
    },
    component: () => import("@/views/exam/mark.vue")
  });
} else {
  routes.push({
    path: "/exam/mark",
    name: "paper-mark",
    meta: {
      needCompany: false,
      needToken: false,
      allowBack: false
    },
    component: () => import("@/views/exam/mark-mobile.vue")
  });
}
routes.push(
  //报告页定向页（标准版） 统一入口
  {
    path: "/candidate-info",
    name: "candidate-info",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/paper/paper-result.vue"),
    beforeEnter: (to, from, next) => {
      //带的参
      let queryString = "";
      if (to.query) {
        for (const k in to.query) {
          queryString += k + "=" + to.query[k] + "&";
        }
      }
      //鉴权
      const tid = String(to?.query?.tid || "");
      //用链接码 查 面试类型 判去向
      CandidateResult.getCid(Number(to?.query?.connectCode), tid).then(
        (res: Ver) => {
          if (res?.reportPath) {
            //最新：后端直接判定跳转逻辑
            if (res.reportPath !== (res.defPath || "/candidate-info")) {
              if (res.openAiComment === 1) {
                //新版 AI解析版加参
                queryString += `&ver=${res.reportVersion}`;
              }
              next(res.reportPath + "?" + queryString);
            } else {
              next();
            }
          } else {
            // 旧逻辑冗余下
            if (res.reportVersion === 2) {
              //新版报告页 陪练版
              next("/c-info?" + queryString);
            } else if (res.openAiComment === 1) {
              //新版 AI解析版
              next(
                "/candidates-ai?" + `${queryString}&ver=${res.reportVersion}`
              );
            }
            //跳普工版 报告页
            else if (["test", "aiworker"].includes(res.examType)) {
              next("/candidates-info?" + queryString);
              //跳诸葛 报告页
            } else if ([91020, 80972].includes(Number(res.companyId))) {
              next("/candidate-infos?" + queryString);
            } else {
              next(); //跳标准 报告页
            }
          }
          //新跳转逻辑
          //   if ([91020, 80972].includes(Number(res.companyId))) {
          //     //跳诸葛 报告页
          //     next("/candidate-infos?" + queryString);
          //   } else if (["test", "aiworker"].includes(res.examType)) {
          //     //跳普工版 报告页
          //     next("/candidates-info?" + queryString);
          //   } else if (res.openAiComment === 1) {
          //     //跳新AI解析版 报告页
          //     next("/candidate-ai?" + queryString);
          //   } else {
          //     //跳标准 报告页（老版、aibuilder通用版）
          //     next();
          //   }
        }
      );
    }
  },
  // 富士康报告页（普工版）
  {
    path: "/candidates-info",
    name: "candidates-info",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/paper/paper-result-f.vue")
  },
  // 临时报告链接
  {
    path: "/candidate-report",
    name: "candidate-report",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/paper/candidate-report.vue")
  },
  //新版报告页(诸葛先行版)
  {
    path: "/candidate-infos",
    name: "candidate-infos",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/paper/paper-result-new.vue")
  },
  //新版报告页 （陪练版）
  {
    path: "/c-info",
    name: "c-info",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => {
      if (isMobile()) {
        //移动端
        return import("@/views/paper/paper-result-new-practice-h5.vue");
      } else {
        //pc端
        return import("@/views/paper/paper-result-new-practice.vue");
      }
    }
  },
  //新版报告页 （AI解析版）
  {
    path: "/candidate-ai",
    name: "candidate-ai",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => {
      if (isMobile()) {
        //移动端
        return import("@/views/paper/paper-result-ai-h5.vue");
      } else {
        //pc端
        return import("@/views/paper/paper-result-ai.vue");
      }
    }
  },
  //新版报告页 2024 结构化
  {
    path: "/report-ai",
    name: "report-ai",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => {
      if (isMobile()) {
        //移动端
        return import(
          "@/views/paper/paper-result-report/paper-result-report-h5.vue"
        );
      } else {
        //pc端
        return import(
          "@/views/paper/paper-result-report/paper-result-report.vue"
        );
      }
    }
  },
  {
    path: "/report-new-ai",
    name: "report-new-ai",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => {
      if (isMobile()) {
        //移动端
        return import(
          "@/views/paper/paper-result-report/paper-result-report-new-h5.vue"
        );
      } else {
        //pc端
        return import(
          "@/views/paper/paper-result-report/paper-result-report-new.vue"
        );
      }
    }
  },
  // 阅读指引
  {
    path: "/guide",
    name: "guide",
    component: () => import("@/views/paper/guide.vue")
  },
  {
    path: "/result",
    name: "result",
    component: () => import("@/views/news/index.vue")
  }
);
//h5 hr端 候选人列表
routes.push(
  {
    path: "/h5-login",
    name: "h5-login",
    meta: {
      needCompany: false,
      needToken: false
    },
    component: () => import("@/views/aihr-h5/login.vue") //登录页
  },
  {
    path: "/h5-candidateList",
    name: "h5-candidateList",
    meta: {
      keepAlive: true
    },
    component: () => import("@/views/aihr-h5/list.vue") //候选人列表页
  },
  {
    path: "/h5-report",
    name: "h5-report",
    component: () => import("@/views/aihr-h5/report.vue") //报告页
  },
  {
    path: "/h5-mark",
    name: "h5-mark",
    component: () => import("@/views/aihr-h5/mark.vue") //评估页
  },
  {
    path: "/h5-search",
    name: "h5-search",
    component: () => import("@/views/aihr-h5/search.vue") //搜索页
  }
);

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes: isNr ? routesNr : routes //牛人星球客户端 路由隔离
});

//公司面试版本 v2 v3 跳转错误页面拦截
function checkExamVersion(to: Route, from: Route, next: Function) {
  if (!vuexStore.companyPower._isAssignedFlag) {
    setTimeout(() => {
      checkExamVersion(to, from, next);
    }, 200);
    return;
  }
  // ban掉以下几种情况：
  const version = vuexStore.companyPower.version;
  console.log("version");
  console.log(version);
  console.log(vuexStore.companyPower._isAssignedFlag);

  // 1.旧版公司任何情况下路由到新版页面
  if (version === ExamType["examV2"] && to?.meta?.examType === "examV3") {
    console.warn("旧版公司禁止路由到新版页面");
    next(false);
  }
  //2.新版公司在无setWeb时候路由到旧版页面
  if (
    version === ExamType["examV3"] &&
    to.query?.teamUse !== "setWeb" &&
    to?.meta?.examType === "examV2"
  ) {
    console.warn("新版公司无setWeb禁止路由到旧版页面");
    next(false);
  }
  //3.三方登录统一跳的dash 路由纠正
  if (to.query?.teamUse === "setWeb") return;
  if (to.path === "/dash" && version === ExamType["examV3"]) {
    next({ path: "/dash-v3", query: to.query });
  }
  if (to.path === "/dash-v3" && version === ExamType["examV2"]) {
    next({ path: "/dash", query: to.query });
  }
}

// 香格里拉需求，集团公司路由跳转到设置中心

router.beforeEach((to, from, next) => {
  // 香格里拉需求，集团公司路由跳转到设置中心
  const companyList = Auth.companyList;
  for (let i = 0; i < companyList.length; i++) {
    const item = companyList[i];
    if (
      item.companyType === "1" &&
      Cookie.get(Constraint.companyIdKey) == item.id &&
      location.hostname !== "localhost"
    ) {
      // 账号下存在集团且没有曾经选择的公司
      window.open(
        Config.accountUrl + "/#/user?companyId=" + Auth.companyId,
        "_self"
      );
      return;
    }
  }

  //!该项目上的涉及 v2 的都跳转到新的路由上，不再使用该项目上的 v2 功能了
  // 组件化路由重定向逻辑
  const componentRoutes = [
    "/exam-component",
    "/candidate-component",
    "/ai-question-store-comp",
    "/message-comp",
    "/message-temp-comp",
    "/export-component",
    "/ai-qa/list-comp",
    "/company/config-comp",
    "/ai-builder-component"
  ];

  // 检查是否需要重定向
  const shouldRedirect = componentRoutes.some(route =>
    to.path.startsWith(route)
  );

  if (shouldRedirect) {
    const redirectUrl = `${location.origin}/v2`;

    // 执行重定向
    window.location.href = redirectUrl;
    return;
  }

  checkExamVersion(to, from, next);
  // setWeb参数持续
  if (from?.query?.teamUse === "setWeb" && to?.query?.teamUse !== "setWeb") {
    next({ path: to.path, query: { ...to.query, teamUse: "setWeb" } });
  }
  if (to?.meta?.keepAlive) {
    // keepAlive组件路由名字与组件名字相同
    vuexStore.addPages(to.name as string);
  }
  if (to.name !== "exam-candidates" && to.name !== "exam-list-v3") {
    vuexStore.removePages("exam-list-v3");
  }
  next();
});

export default router;
